import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo/Typo'
import { Vertical } from 'component/Vertical/Vertical'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { store } from 'page/tryon/store/TryOnPageStore'
import { Item } from 'type/Inference'

type Props = {
  item: Item
  shape: boolean
}

function extractShape(item: Item): string | undefined {
  if (item.dress_shape_type === 'top') return i18n('DressShapeTop')
  if (item.dress_shape_type === 'bottom') return i18n('DressShapeBottom')
  return undefined
}

export const ItemTitle = observer((props: Props) => {
  const { show_name } = store.it
  const { item } = props
  const { brand } = item
  const shape = props.shape ? extractShape(item) : undefined
  const product = show_name ? item.product : ''

  return <Vertical center top>
    {shape && <Typo size={11} upper>
      {shape}
    </Typo>}
    <Gap height={8} />
    {brand && <Typo size={11} secondary upper center balance>
      {brand}
    </Typo>}
    {product && <Typo size={13} medium upper center balance>
      {product}
    </Typo>}
  </Vertical>
})
